import {
  ChannelEnum,
  MasterNotificationCategoryEnum,
} from "@/__generated__/graphql";

export enum NotificationChannel {
  PUSH_NOTIF = ChannelEnum.PushNotif,
  EMAIL = ChannelEnum.Email,
  WHATSAPP = ChannelEnum.Whatsapp,
}

export enum NotificationCategory {
  VISIT_REMINDER = MasterNotificationCategoryEnum.VisitReminder,
  PROMO_AND_DISCOUNT = MasterNotificationCategoryEnum.PromoAndDiscount,
  BILLING = MasterNotificationCategoryEnum.Billing, // always enabled
}
export type NotificationSettings = {
  channels: NotificationChannel[];
  categories: NotificationCategory[];
};

export type NotificationSettingValues = Record<
  NotificationChannel | NotificationCategory,
  boolean
>;

export const transformNotificationSettingsInput = (
  categories?: MasterNotificationCategoryEnum[],
  channels?: ChannelEnum[],
): NotificationSettingValues => {
  const values = {
    [NotificationChannel.PUSH_NOTIF]: false,
    [NotificationChannel.EMAIL]: false,
    [NotificationChannel.WHATSAPP]: false,
    [NotificationCategory.VISIT_REMINDER]: false,
    [NotificationCategory.PROMO_AND_DISCOUNT]: false,
    [NotificationCategory.BILLING]: true,
  };

  if (channels) {
    values[NotificationChannel.PUSH_NOTIF] = channels.includes(
      ChannelEnum.PushNotif,
    );
    values[NotificationChannel.EMAIL] = channels.includes(ChannelEnum.Email);
    values[NotificationChannel.WHATSAPP] = channels.includes(
      ChannelEnum.Whatsapp,
    );
  }

  if (categories) {
    values[NotificationCategory.VISIT_REMINDER] = categories.includes(
      MasterNotificationCategoryEnum.VisitReminder,
    );
    values[NotificationCategory.PROMO_AND_DISCOUNT] = categories.includes(
      MasterNotificationCategoryEnum.PromoAndDiscount,
    );
  }

  return values;
};

export const transformNotificationSettingsPayload = (
  settings: NotificationSettingValues,
): NotificationSettings => {
  return {
    channels: Object.entries(settings)
      .filter(([key, value]) => value && key in NotificationChannel)
      .map(([key]) => key as NotificationChannel),
    categories: Object.entries(settings)
      .filter(([key, value]) => value && key in NotificationCategory)
      .map(([key]) => key as NotificationCategory),
  };
};
